import { Reveal } from "./Reveal";
import { personal, personalChips } from "../data/content";

// Quiet personal band: discipline and hobbies, in her own words.
export default function Personal() {
  return (
    <section className="border-b border-hairline bg-canvasAlt" data-testid="personal-section">
      <div className="container-x py-14 sm:py-16">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.28em] text-teal">Outside of work</p>
          <p className="mt-5 max-w-2xl font-display text-xl sm:text-2xl text-ink leading-snug" data-testid="personal-line">
            {personal}
          </p>
          <div className="mt-6 flex flex-wrap gap-2" data-testid="personal-chips">
            {personalChips.map((chip) => (
              <span key={chip} className="font-mono text-[11px] tracking-wide text-teal bg-teal-light px-3 py-1.5">
                {chip}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
